import { render, staticRenderFns } from "./Casual_days.vue?vue&type=template&id=56467d94&scoped=true&"
import script from "./Casual_days.vue?vue&type=script&lang=js&"
export * from "./Casual_days.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56467d94",
  null
  
)

export default component.exports